export const GEMBA_WALK_CALLER = 'GEMBA_WALK'
